<mat-divider></mat-divider>
<mat-list-item class="cais-list-item-title">Natural Person/Legal Entity List Details</mat-list-item>

<!-- TID Generator Button -->
<div class="ui-grid-col-12 container text-right nopadding">
  <div class="col-lg-12">
    <label for="TIDCorrectionBtn" class="nopadding">
      <button pButton id="TIDCorrectionBtn" type="button" [ngClass]="isClickOnTIDCorrection ? 'activeTIDCorrectionBtn': ''" [disabled]="false" label="TID Correction"  class="button fdid-customer-tid--button btn-lg fdid-customer-tid--button-label" (click)="TIDCorrectionConfirmation();"></button>
    </label>
    <label for="TIDGeneratorDialogBtn">
      <button pButton id="TIDGeneratorDialogBtn" type="button" [disabled]="false" label="TID Generator"
      (click)="openTIDGenrator()" class="button fdid-customer-tid--button btn-lg fdid-customer-tid--button-label"></button>
      <!-- TID Generator -->
      <app-tid-generator></app-tid-generator>
    </label>
    <!-- <label class="nopadding">
      <button pButton id="AddEditNaturalPersonTabBtn" type="button" [disabled]="false" label="Add Natural Person"
        (click)="addNewTab('Natural Person');" class="button btn-lg p-button-text"></button>
    </label>
    <label class="nopadding">
      <button pButton id="AddEditLegalEntityTabBtn" type="button" [disabled]="false" label="Add Legal Entity"
        (click)="addNewTab('Legal Entity');" class="button btn-lg p-button-text"></button>
    </label> -->
  </div>
</div>
<!-- End of TID Generator Button -->

<!-- Natural Person/Legal Entity List -->
<div class="ui-grid-col-12 container card">
<p-tabs [id]="'editNaturalPersonLegalEntityTab'" [value]="selectedTabIndex" class="customerlist-tab" (valueChange)="handleChange($event)" scrollable>
  <p-tablist>
    @for(NaturalPerson of (NaturalPersons | slice:1); track NaturalPerson.tabIndex + '-'+ $index; let i = $index){
    <p-tab [value]="NaturalPerson.tabIndex"
      [ngClass]="this.caisServiceService.NaturalPersonDataDetails[i]?.tidUpdate===this.caisServiceService.TIDUpdateStatuses[0] ? 'preTIDUpdateHeader' : (this.caisServiceService.NaturalPersonDataDetails[i]?.tidUpdate===this.caisServiceService.TIDUpdateStatuses[1] ? 'postTIDUpdateHeader' : '')"
      [style]="{'border':(this.caisServiceService.NaturalPersonDataDetails[i] && this.caisServiceService.NaturalPersonDataDetails[i].errorFields) || findErrorIndexTab(NaturalPerson.inCustomerRecordID,i)? '2px groove red' : 'none'}">
      {{NaturalPerson.name}}
    </p-tab>
    }
    @for (LegalEntity of (LegalEntities | slice:1); track LegalEntity.tabIndex + '-'+ $index;let i = $index){
    <p-tab [value]="LegalEntity.tabIndex"
      [ngClass]="this.caisServiceService.LegalEntityDataDetails[i]?.tidUpdate===this.caisServiceService.TIDUpdateStatuses[0] ? 'preTIDUpdateHeader' : (this.caisServiceService.LegalEntityDataDetails[i]?.tidUpdate===this.caisServiceService.TIDUpdateStatuses[1] ? 'postTIDUpdateHeader' : '')"
      [style]="{'border':this.caisServiceService.LegalEntityDataDetails[i] && this.caisServiceService.LegalEntityDataDetails[i].errorFields || findErrorIndexTab(LegalEntity.inCustomerRecordID,i)? '2px groove red' : 'none'}">
      {{LegalEntity.name}}
    </p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    @for(NaturalPerson of (NaturalPersons | slice:1); track NaturalPerson.tabIndex + '-'+ $index; let i = $index){
    <ng-container>
      <p-tabpanel [value]="NaturalPerson.tabIndex">
        @if(this.caisServiceService.NaturalPersonDataDetails.length>0){
        <div class="ui-grid-col-12 container contents">
          <!-- Natural Person Fields -->
          @for(viewRow of NaturalPersonScreenDataDetails; track viewRow.ui_Field_Name + '-'+ $index){
            @if(!viewRow.isOptionalFields){
              <!-- Generate Encrypted TID Value -->
                @if(viewRow.ui_Field_Name==='TID Value'){
                  <app-tid-generator [GeneratorType]="'formTIDGenerator'" [UserType]="'NaturalPerson'" [TIDType]="this.caisServiceService.NaturalPersonDataDetails[i].tidType" [foreignTIDType]="this.caisServiceService.NaturalPersonDataDetails[i].foreignTIDType" (receiveTIDValue)="applyTIDValue('NaturalPerson', i);"></app-tid-generator>
                }
              <!-- End of Generating Encrypted TID Value -->
              <span
                [ngClass]="(editScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || CommonNegotiatedFields.includes(viewRow.ui_Field_Name)) ? 'notdisplay':'' ">
                <span
                  [ngClass]="(viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4')">
                  <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                    <div
                      [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                      @if(viewRow.isrequired){
                      <strong class="error-mark">*</strong>
                      }
                    </div>
                    <!-- Switch for preserving Important Field value -->
                    @if(!['Add Natural Person'].includes(NaturalPerson.name) &&
                    editDisabledFields.includes(viewRow.ui_Field_Name)){
                    <div [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
                      <span>
                        <ng-container>
                          @if(isClickOnTIDCorrection){
                          <p-toggleswitch [(ngModel)]="isClickOnTIDCorrection"
                            styleClass="caisInputSwitch"></p-toggleswitch>
                          }
                          @else{
                          <p-toggleswitch (onChange)="NPTIDSwitches[i] = !$event.checked;"
                            styleClass="caisInputSwitch"></p-toggleswitch>
                          }
                        </ng-container>
                      </span>
                    </div>
                    }
                    <!-- End of Switch for preserving Important Field value -->
                    <div
                      [ngClass]="(viewRow.isLargeField ? (!['Add Natural Person'].includes(NaturalPerson.name) && editDisabledFields.includes(viewRow.ui_Field_Name) ? 'ui-g-12 ui-md-7 ui-lg-7 quick-view-grid-row-hg' : 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg') : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      @if(viewRow.field_Name !='yearOfBirth'){
                      <span>
                        @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                        <ng-container>
                          <input pInputText [id]="viewRow.field_Name+'string'"
                            [(ngModel)]="this.caisServiceService.NaturalPersonDataDetails[i][viewRow.field_Name]"
                            [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : (['Add Natural Person'].includes(NaturalPerson.name) && editDisabledFields.includes(viewRow.ui_Field_Name) ? false : (editDisabledFields.includes(viewRow.ui_Field_Name) && NPTIDSwitches[i]===false ? NPTIDSwitches[i] : viewRow.isDisable))"
                            [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')"
                            [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off"
                            [maxlength]="viewRow.maximumLength"
                            [ngClass]="(this.caisServiceService.NaturalPersonDataDetails[i].errorFields && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorField' : ''" />
                          <span
                            [ngClass]="(this.caisServiceService.NaturalPersonDataDetails[i].errorFields && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.NaturalPersonDataDetails[i].errorFields
                            && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                            this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] :
                            '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'date'){
                        <ng-container>
                          <p-datepicker inputId="basic" [touchUI]="true"
                            [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')"
                            [(ngModel)]="this.caisServiceService.NaturalPersonDataDetails[i][viewRow.field_Name]"
                            [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : viewRow.isDisable"
                            dateFormat="yy-mm-dd" appendTo="body"
                            [ngClass]="(this.caisServiceService.NaturalPersonDataDetails[i].errorFields && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                            placeholder="YYYY-MM-DD" [motionOptions]="{ duration: 0 }"></p-datepicker>
                          <span
                            [ngClass]="(this.caisServiceService.NaturalPersonDataDetails[i].errorFields && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.NaturalPersonDataDetails[i].errorFields
                            && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                            this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] :
                            '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' &&
                        (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                        <ng-container>
                          <p-select appendTo="body" [name]="viewRow.field_Name +'singleselect'"
                            [id]="viewRow.field_Name+'singleselect'" [options]="viewRow.dropdownvalue"
                            [(ngModel)]="this.caisServiceService.NaturalPersonDataDetails[i][viewRow.field_Name]"
                            [showClear]="true"
                            [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : caisServiceService.isDisabled(viewRow, this.caisServiceService.NaturalPersonDataDetails[i])"
                            (onChange)="caisServiceService.onChangeSelectionBox(viewRow, this.caisServiceService.NaturalPersonDataDetails[i])"
                            [placeholder]="'Enter Value'" class="maxChoiceWidth" [filter]="true" filterBy="label"
                            [ngClass]="(this.caisServiceService.NaturalPersonDataDetails[i].errorFields && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''"
                            styleClass="fdid-customer-form-dropdown">
                            <ng-template pTemplate="selectedItem">
                              <div>
                                <div>{{caisServiceService.NaturalPersonDataDetails[i][viewRow.field_Name]}}</div>
                              </div>
                            </ng-template>
                          </p-select>
                          <span
                            [ngClass]="(this.caisServiceService.NaturalPersonDataDetails[i].errorFields && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.NaturalPersonDataDetails[i].errorFields
                            && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                            this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] :
                            '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' &&
                        (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                        <ng-container>
                          <p-multiSelect appendTo="body" [name]="viewRow.field_Name +'array'"
                            [id]="viewRow.field_Name+'array'" [options]="viewRow.dropdownvalue"
                            [(ngModel)]="this.caisServiceService.NaturalPersonDataDetails[i][viewRow.field_Name]"
                            [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : viewRow.isDisable"
                            [placeholder]="'Please select choices'"
                            class="maxMultiChoiceWidth fdid-customer-multiselect-dropdown"
                            [ngClass]="(this.caisServiceService.NaturalPersonDataDetails[i].errorFields && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                          </p-multiSelect>
                          <span
                            [ngClass]="(this.caisServiceService.NaturalPersonDataDetails[i].errorFields && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.NaturalPersonDataDetails[i].errorFields
                            && this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                            this.caisServiceService.NaturalPersonDataDetails[i]['errorFields'][viewRow.field_Name] :
                            '')}}</span>
                        </ng-container>
                        }
                      </span>
                      }
                      @if(viewRow.field_Name =='yearOfBirth'){
                      <span>
                        <input pInputText inputId="yearOfBirth" class="birthYear" [id]="viewRow.field_Name+i"
                          [(ngModel)]="this.caisServiceService.NaturalPersonDataDetails[i][viewRow.field_Name]"
                          (keyup)="caisServiceService.maskYear()" (focus)="caisServiceService.unMaskYear(viewRow.value)"
                          (focusout)="caisServiceService.maskYear()" />
                      </span>
                      }
                      @if((viewRow?.dropdown | lowercase) === 'no' && !viewRow.isDisable &&
                      !editDisabledFields.includes(viewRow.ui_Field_Name) && (viewRow?.datatype | lowercase) != 'date'){
                      <span>
                        <a aria-label="Clear Value"> <i pTooltip="Clear Value"
                            (click)="this.caisServiceService.NaturalPersonDataDetails[i][viewRow.field_Name]=null"
                            tooltipPosition="right" class="fa fa-times times-icon" aria-hidden="true"></i></a>
                      </span>
                      }
                    </div>
                  </div>
                </span>
              </span>
              <!-- Instructions for TID Value Generation -->
                @if(viewRow.ui_Field_Name==='TID Value'){
                  <app-tid-generator [GeneratorType]="'TIDGeneratorInstructions'"></app-tid-generator>
                }
              <!-- End of Instructions for TID Value Generation -->
            }
          }
          <!-- End of Natural Person Fields -->
        </div>
        }
        <!-- Natural Person Address Details -->
        @if(caisServiceService.hasAnyActiveField(addressColumns)) {
          <div class="ui-grid-col-12 container contents">
            <p-table id="EditNaturalPersonAddressTable" [columns]="addressColumns"
              [value]="this.caisServiceService.NaturalPersonAddressDetails[i]" class="AddressTable"
              [resizableColumns]="true" #edit_dt>
              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                  @for(col of columns; track col.field + '-' + $index; let i = $index){
                  <col style="min-width: 120px;">
                  }
                </colgroup>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th id="colHeaderNaturalPersonEditAction"></th>
                  @for(col of columns; track col.field + '-' + $index; let i = $index){
                  <th id="colHeader">
                    {{col.header}}
                  </th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
                <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri">
                  @if((this.caisServiceService.NaturalPersonAddressDetails[i].length === (ri+1))){
                  <td [ngClass]="{'disabledLink': true, 'text-center': true}"><a
                      (click)="this.caisServiceService.NaturalPersonAddressDetails[i].push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em
                        class="pi pi-plus"></em></a></td>
                  }
                  @if((this.caisServiceService.NaturalPersonAddressDetails[i].length !== (ri+1))){
                  <td [ngClass]="{'disabledLink': true, 'text-center': true}"><a
                      (click)="this.caisServiceService.NaturalPersonAddressDetails[i].splice(ri+1,1);"><em
                        class="pi pi-minus"></em></a></td>
                  }
                  @for(col of columns; track col.field + '-' + $index; let i = $index){
                  <td pEditableColumn
                    [ngClass]="{'errorFieldBorderBottom':(rowData['errorFields'] && rowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                    @if(!['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [id]="rowData[col.field]+'string'" [(ngModel)]="rowData[col.field]"
                          [disabled]="col.disabled" [maxlength]="col.maxlength">
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{rowData[col.field]}}
                      </ng-template>
                    </p-cellEditor>
                    }
                    <!-- Country & Region Code Menu List -->
                    @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                    <p-select [id]="rowData[col.field]+'singleselect'" appendTo="body" [options]="col.dropdownvalue"
                      [(ngModel)]="rowData[col.field]" [showClear]="true" [filter]="true" [placeholder]="'Enter Value'"
                      class="removeborder maxChoiceWidth" [disabled]="col.disabled" 
                      (ngModelChange)="rowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && rowData['addr_regionCode'] && (!rowData['addr_countryCode'] || ['US', 'CA'].includes(rowData['addr_countryCode']))) ? rowData['addr_regionCode'].slice(0,2) : rowData['addr_countryCode'])"
                      styleClass="fdid-customer-form-dropdown justify-center table-column-dropdown" [ngClass]="['addr_regionCode'].includes(col.field) ? 'table-column-addr_regionCode' : ''">
                    </p-select>
                    }
                  </td>
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
        <!-- End of Natural Person Address Details -->
        <!-- Add/Save Natural Person -->
        <div class="ui-dialog-buttonpane ui-helper-clearfix pull-right">
          <p-button type="button" icon="fa fa-close" id="ResetNaturalPerson" class="userActionBtn edit-footer-button"
            (click)="resetNaturalPerson(i);" label="Reset"></p-button>
          <p-button type="button" icon="fa fa-trash" id="RemoveNaturalPerson" class="userActionBtn edit-footer-button"
            (click)="removeNaturalPerson(i);" label="Remove" [disabled]="(NaturalPerson.id===0)"></p-button>
        </div>
        <!-- End of Add/Save Natural Person -->
      </p-tabpanel>
    </ng-container>
    }
    @for (LegalEntity of (LegalEntities | slice:1); track LegalEntity.tabIndex + '-'+ $index;let i = $index){
    <ng-container>
      <p-tabpanel [value]="LegalEntity.tabIndex">
        @if(this.caisServiceService.LegalEntityDataDetails.length>0){
        <div class="ui-grid-col-12 container contents">
          <!-- Legal Entity Fields -->
          @for (viewRow of LegalEntityScreenDataDetails; track viewRow.ui_Field_Name + '-'+ $index){
            @if(!viewRow.isOptionalFields){
              <!-- Generate Encrypted TID Value -->
                @if(viewRow.ui_Field_Name==='TID Value'){
                  <app-tid-generator [GeneratorType]="'formTIDGenerator'" [UserType]="'LegalEntity'" [TIDType]="this.caisServiceService.LegalEntityDataDetails[i].tidType" [foreignTIDType]="this.caisServiceService.LegalEntityDataDetails[i].foreignTIDType" (receiveTIDValue)="applyTIDValue('LegalEntity', i);"></app-tid-generator>
                }
              <!-- End of Generating Encrypted TID Value -->
              <span
                [ngClass]="(editScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || CommonNegotiatedFields.includes(viewRow.ui_Field_Name))? 'notdisplay':'' ">
                <span
                  [ngClass]="(viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4')">

                  <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                    <div
                      [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                      @if(viewRow.isrequired){
                      <strong class="error-mark">*</strong>
                      }
                    </div>
                    <!-- Switch for preserving Important Field value -->
                    @if(!['Add Legal Entity'].includes(LegalEntity.name) &&
                    editDisabledFields.includes(viewRow.ui_Field_Name)){
                    <div [ngClass]="'ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg'">
                      <span>
                        <ng-container>
                          @if(isClickOnTIDCorrection){
                          <p-toggleswitch [(ngModel)]="isClickOnTIDCorrection"
                            styleClass="caisInputSwitch"></p-toggleswitch>
                          }
                          @else{
                          <p-toggleswitch (onChange)="LETIDSwitches[i] = !$event.checked;"
                            styleClass="caisInputSwitch"></p-toggleswitch>
                          }
                        </ng-container>
                      </span>
                    </div>
                    }
                    <!-- End of Switch for preserving Important Field value -->
                    <div
                      [ngClass]="(viewRow.isLargeField ? (!['Add Legal Entity'].includes(LegalEntity.name) && editDisabledFields.includes(viewRow.ui_Field_Name) ? 'ui-g-12 ui-md-7 ui-lg-7 quick-view-grid-row-hg' : 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg') : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <span>
                        @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'no'){
                        <ng-container>
                          <input pInputText [id]="viewRow.field_Name+'string'"
                            [(ngModel)]="this.caisServiceService.LegalEntityDataDetails[i][viewRow.field_Name]"
                            [title]="this.caisServiceService.LegalEntityDataDetails[i][viewRow.field_Name]"
                            [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : (['Add Legal Entity'].includes(LegalEntity.name) && editDisabledFields.includes(viewRow.ui_Field_Name) ? false : (editDisabledFields.includes(viewRow.ui_Field_Name) && LETIDSwitches[i]===false ? LETIDSwitches[i] : viewRow.isDisable))"
                            [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')"
                            [attr.data-multiEditDisabled]="viewRow.isMultiDisabled" autocomplete="off"
                            [ngClass]="(this.caisServiceService.LegalEntityDataDetails[i].errorFields && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorField' : ''"
                            (keyup)="setTIDType(viewRow.field_Name, i)"
                            (ngModelChange)="AutoGenerateTID($event, viewRow.field_Name, i)" />
                          <span
                            [ngClass]="(this.caisServiceService.LegalEntityDataDetails[i].errorFields && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.LegalEntityDataDetails[i].errorFields
                            && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                            this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] :
                            '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'date'){
                        <ng-container>
                          <p-datepicker inputId="basic" [touchUI]="true"
                            [placeholder]="(viewRow.placeholder ? viewRow.placeholder : '')"
                            [(ngModel)]="this.caisServiceService.LegalEntityDataDetails[i][viewRow.field_Name]"
                            [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : viewRow.isDisable"
                            dateFormat="yy-mm-dd" appendTo="body"
                            [ngClass]="(this.caisServiceService.LegalEntityDataDetails[i].errorFields && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDateField' : ''"
                            placeholder="YYYY-MM-DD" [motionOptions]="{ duration: 0 }"></p-datepicker>
                          <span
                            [ngClass]="(this.caisServiceService.LegalEntityDataDetails[i].errorFields && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.LegalEntityDataDetails[i].errorFields
                            && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                            this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] :
                            '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'string' && (viewRow?.dropdown | lowercase) === 'yes' &&
                        (viewRow?.dropdowntype | lowercase) === 'singleselect'){
                        <ng-container>
                          <p-select appendTo="body" [name]="viewRow.field_Name +'singleselect'"
                            [id]="viewRow.field_Name+'singleselect'" [options]="viewRow.dropdownvalue"
                            [(ngModel)]="this.caisServiceService.LegalEntityDataDetails[i][viewRow.field_Name]"
                            [showClear]="true"
                            [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : caisServiceService.isDisabled(viewRow, this.caisServiceService.LegalEntityDataDetails[i])"
                            (onChange)="caisServiceService.onChangeSelectionBox(viewRow, this.caisServiceService.LegalEntityDataDetails[i])"
                            [placeholder]="'Enter Value'" class="maxChoiceWidth" [filter]="true" filterBy="label"
                            [ngClass]="(this.caisServiceService.LegalEntityDataDetails[i].errorFields && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''"
                            styleClass="fdid-customer-form-dropdown">
                            <ng-template pTemplate="selectedItem">
                              <div>
                                <div>{{caisServiceService.LegalEntityDataDetails[i][viewRow.field_Name]}}</div>
                              </div>
                            </ng-template>
                          </p-select>
                          <span
                            [ngClass]="(this.caisServiceService.LegalEntityDataDetails[i].errorFields && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.LegalEntityDataDetails[i].errorFields
                            && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                            this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] :
                            '')}}</span>
                        </ng-container>
                        }
                        @if((viewRow?.datatype | lowercase) === 'array' && (viewRow?.dropdown | lowercase) === 'yes' &&
                        (viewRow?.dropdowntype | lowercase) === 'multiselect'){
                        <ng-container>
                          <p-multiSelect appendTo="body" [name]="viewRow.field_Name +'array'"
                            [id]="viewRow.field_Name+'array'" [options]="viewRow.dropdownvalue"
                            [(ngModel)]="this.caisServiceService.LegalEntityDataDetails[i][viewRow.field_Name]"
                            [disabled]="(isClickOnTIDCorrection && !editabledCaisCorrectionFields.includes(viewRow.ui_Field_Name)) ? true : viewRow.isDisable"
                            [placeholder]="'Please select choices'"
                            class="maxMultiChoiceWidth fdid-customer-multiselect-dropdown"
                            [ngClass]="(this.caisServiceService.LegalEntityDataDetails[i].errorFields && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'errorDropdownField' : ''">
                          </p-multiSelect>
                          <span
                            [ngClass]="(this.caisServiceService.LegalEntityDataDetails[i].errorFields && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ? 'text-error' : ''">{{((this.caisServiceService.LegalEntityDataDetails[i].errorFields
                            && this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name]) ?
                            this.caisServiceService.LegalEntityDataDetails[i]['errorFields'][viewRow.field_Name] :
                            '')}}</span>
                        </ng-container>
                        }
                      </span>
                      @if((viewRow?.dropdown | lowercase) === 'no' && !viewRow.isDisable &&
                      !editDisabledFields.includes(viewRow.ui_Field_Name) && (viewRow?.datatype | lowercase) != 'date'){
                      <span>
                        <a aria-label="Clear Value"> <i pTooltip="Clear Value"
                            (click)="this.caisServiceService.LegalEntityDataDetails[i][viewRow.field_Name]=null"
                            tooltipPosition="right" class="fa fa-times times-icon" aria-hidden="true"></i></a>
                      </span>
                      }
                    </div>
                  </div>
                </span>
              </span>
              <!-- Instructions for TID Value Generation -->
                @if(viewRow.ui_Field_Name==='TID Value'){
                  <app-tid-generator [GeneratorType]="'TIDGeneratorInstructions'"></app-tid-generator>
                }
              <!-- End of Instructions for TID Value Generation -->
            }
          }
          <!-- End of Legal Entity Fields -->
        </div>
        }
        <!-- Legal Entity Address Details -->
        @if(caisServiceService.hasAnyActiveField(addressColumns)) {
          <div class="ui-grid-col-12 container contents">
            <p-table id="EditLegalEntityAddressTable" [columns]="addressColumns"
              [value]="this.caisServiceService.LegalEntityAddressDetails[i]" class="AddressTable"
              [resizableColumns]="true" #edit_dt>
              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                  @for(col of columns; track col.field + '-'+ $index){
                  <col style="min-width: 120px;">
                  }
                </colgroup>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th id="colHeaderLegalEntityEditAction"></th>
                  @for(col of columns; track col.field + '-'+ $index){
                  <th id="colHeader">
                    {{col.header}}
                  </th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
                <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri">
                  @if((this.caisServiceService.LegalEntityAddressDetails[i].length === (ri+1))){
                  <td [ngClass]="{'disabledLink': true, 'text-center': true}"><a
                      (click)="this.caisServiceService.LegalEntityAddressDetails[i].push({'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''});"><em
                        class="pi pi-plus"></em></a></td>
                  }
                  @if((this.caisServiceService.LegalEntityAddressDetails[i].length !== (ri+1))){
                  <td [ngClass]="{'disabledLink': true, 'text-center': true}"><a
                      (click)="this.caisServiceService.LegalEntityAddressDetails[i].splice(ri+1,1);"><em
                        class="pi pi-minus"></em></a></td>
                  }
                  @for(col of columns; track col.field + '-'+ $index){
                  <td pEditableColumn
                    [ngClass]="{'errorFieldBorderBottom':(rowData['errorFields'] && rowData['errorFields'][col.field]), 'text-center':(['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field)), 'text-left':(!['addr_city', 'addr_regionCode', 'addr_countryCode', 'addr_postalCode'].includes(col.field))}">
                    @if(!['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText type="text" [id]="rowData[col.field]+'string'" [(ngModel)]="rowData[col.field]"
                          [disabled]="col.disabled" [maxlength]="col.maxlength">
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{rowData[col.field]}}
                      </ng-template>
                    </p-cellEditor>
                    }
                    <!-- Country & Region Code Menu List -->
                    @if(['addr_regionCode', 'addr_countryCode'].includes(col.field)){
                    <p-select [id]="rowData[col.field]+'singleselect'" appendTo="body" [options]="col.dropdownvalue"
                      [(ngModel)]="rowData[col.field]" [showClear]="true" [filter]="true" [placeholder]="'Enter Value'"
                      class="removeborder maxChoiceWidth" [disabled]="col.disabled" 
                      (ngModelChange)="rowData['addr_countryCode'] = ((['addr_regionCode'].includes(col.field) && rowData['addr_regionCode'] && (!rowData['addr_countryCode'] || ['US', 'CA'].includes(rowData['addr_countryCode']))) ? rowData['addr_regionCode'].slice(0,2) : rowData['addr_countryCode'])"
                      styleClass="fdid-customer-form-dropdown justify-center table-column-dropdown" [ngClass]="['addr_regionCode'].includes(col.field) ? 'table-column-addr_regionCode' : ''">
                    </p-select>
                    }
                  </td>
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
        <!-- End of Legal Entity Address Details -->
        <!-- Add/Save Legal Entity -->
        <div class="ui-dialog-buttonpane ui-helper-clearfix pull-right">
          <p-button type="button" icon="fa fa-close" id="ResetLegalEntity" class="userActionBtn edit-footer-button"
            (click)="resetLegalEntity(i);" label="Reset"></p-button>
          <p-button type="button" icon="fa fa-trash" id="RemoveLegalEntity" class="userActionBtn edit-footer-button"
            (click)="removeLegalEntity(i);" label="Remove" [disabled]="(LegalEntity.id===0)"></p-button>
        </div>
        <!-- End of Add/Save Legal Entity -->
      </p-tabpanel>
    </ng-container>
    }
  </p-tabpanels>
</p-tabs>

</div>
<!-- End of Natural Person/Legal Entity List -->

<!-- Confirmation Dialog-Box -->
<p-confirmDialog 
  acceptLabel="Ok" 
  key="informationDialoge" 
  [rejectVisible]="true" 
  appendTo="body" 
  header="Information" 
  icon="pi pi-exclamation-triangle" 
  [baseZIndex]="999999"
  styleClass="confirm-dialog">
</p-confirmDialog>
<p-confirmDialog 
id="cais-correction-confirm-dialog"
styleClass="confirm-dialog"
key="confirmationDialog" 
appendTo="body" header="Confirmation"
icon="pi pi-exclamation-triangle"
[baseZIndex]="999999">
</p-confirmDialog>